var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"seo-only"},[_vm._v("佑昇生殖中心｜試管嬰兒、不孕症治療與凍卵諮詢")]),_c('Carousel'),_c('MainTitle'),_c('KnowUSoon',{attrs:{"is-index":true}}),_c('Service',{attrs:{"isIndex":""}}),_c('OurTeam'),_c('ContactUs',{attrs:{"is-index":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }